<script>
export default {
    props: ['data'],
    name: "ipImagesSwiper",
    data() {
        return {
            swiperOptions1: {
                observer: true,
                observeParents: true,
                simulateTouch: false,
                loop: true,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
            },
            swiperOptions2: {
                observer: true,
                observeParents: true,
                simulateTouch: false,
                loop: false,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
            },
        };
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.$swiper
        }
    },
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <swiper class="ip_images_swiper" ref="mySwiper" :options="data.length > 1 ? swiperOptions1 : swiperOptions2">
        <swiper-slide v-for="(item, index) in data" :key="index">
            <div class="layout_bg bg" :style="`background-image: url(${item});`"></div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
</template>

<style scoped lang="scss">
.ip_images_swiper{
    width: 5.56rem;
    height: 5.12rem;
    flex-shrink: 0;
    @media only screen and (max-width: 750px) {
        width: 7.5rem;
        height: 8.5rem;
        margin-left: -.3rem;
    }
    .swiper-pagination{
        display: flex;
        justify-content: center;
        gap: .1rem;
        @media only screen and (max-width: 750px) {
            bottom: .6rem;
        }
        /deep/.swiper-pagination-bullet{
            width: .18rem;
            height: .06rem;
            border-radius: .06rem;
            background: none;
            border: 1px solid #fff;
            opacity: 1;
            margin: 0;
            &-active{
                background: #fff;
            }
            @media only screen and (max-width: 750px) {
                width: .12rem;
                height: .12rem;
            }
        }
    }
}
</style>